import React, { useEffect, useRef, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { getRequest, pathname } from "@react/helpers/fetch"

const INPUT = "w-full h-8 px-2.5 rounded-md border border-slate-200 text-[12.5px] focus:outline-none focus:ring-2 focus:ring-brand-500/30 focus:border-brand-400"

const ProductSearch = ({ url, placeholder, onSelect, autoFocus = false }) => {
  const [query, setQuery]     = useState("")
  const [results, setResults] = useState([])
  const [open, setOpen]       = useState(false)
  const [busy, setBusy]       = useState(false)
  const wrapRef  = useRef(null)
  const timerRef = useRef(null)

  useEffect(() => {
    const onDocClick = event => { if (!wrapRef.current?.contains(event.target)) setOpen(false) }
    document.addEventListener("click", onDocClick, true)
    return () => document.removeEventListener("click", onDocClick, true)
  }, [])

  const search = needle => {
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => {
      setBusy(true)
      getRequest(pathname({ path: url.replace(/\.json$/, ""), format: "json", params: { q: needle } }))
        .then(rows => { setResults(Array.isArray(rows) ? rows : []); setOpen(true) })
        .catch(() => setResults([]))
        .finally(() => setBusy(false))
    }, 220)
  }

  const handleChange = event => { setQuery(event.target.value); search(event.target.value) }
  const handleFocus  = () => { if (results.length === 0) search(query); else setOpen(true) }
  const pick = product => { onSelect(product); setQuery(""); setResults([]); setOpen(false) }

  return (
    <div className="relative" ref={wrapRef}>
      <FontAwesomeIcon icon={busy ? "circle-notch" : "magnifying-glass"} spin={busy} className="absolute left-2.5 top-1/2 -translate-y-1/2 w-3 h-3 text-slate-400" />
      <input className={`${INPUT} pl-7`} value={query} onChange={handleChange} onFocus={handleFocus} placeholder={placeholder} autoFocus={autoFocus} />
      {open && (
        <div className="absolute z-30 mt-1 w-full min-w-[280px] bg-white border border-slate-200 rounded-md shadow-lg max-h-56 overflow-y-auto">
          {results.length === 0 ? (
            <div className="px-3 py-2 text-[12.5px] text-slate-400">{I18n.t("projects.engagements.form.no_match")}</div>
          ) : results.map(product => (
            <button key={product.id} type="button" onClick={() => pick(product)} className="w-full text-left px-3 py-2 hover:bg-slate-50 flex items-center justify-between gap-3">
              <span className="text-[12.5px] text-slate-800 truncate">{product.name}</span>
              <span className="text-[11.5px] tabular-nums text-slate-500 shrink-0">{product.purchase_price?.formatted}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default ProductSearch
